export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/scenario', item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error); })
    })
  },

  fetchScenarioListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/scenario")
        .then((response) => {
          commit('SET_SCENARIOS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateItem({ commit }, scenario) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/scenario', scenario)
        .then((response) => {
          commit('UPDATE_SCENARIO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('geo/scenario/' + itemId)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
